import { render } from "./DataByPath.vue?vue&type=template&id=867d5efc&scoped=true"
import script from "./DataByPath.vue?vue&type=script&lang=js"
export * from "./DataByPath.vue?vue&type=script&lang=js"

import "./DataByPath.vue?vue&type=style&index=0&id=867d5efc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-867d5efc"]])

export default __exports__